package utils

object GameDimensions {
    const val V_WIDTH = 960
    const val V_HEIGHT = 540
    const val PPM = 100

}
